export var ContentType;
(function (ContentType) {
    ContentType["PLAIN_TEXT"] = "PLAIN_TEXT";
    ContentType["DRAFTJS"] = "DRAFTJS";
    ContentType["RICH_CONTENT"] = "RICH_CONTENT";
})(ContentType || (ContentType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["ANONYMOUS"] = "ANONYMOUS";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["USER"] = "USER";
    IdentityType["SERVICE"] = "SERVICE";
    /** indicates everyone who is a member of a group */
    IdentityType["MEMBER_GROUP"] = "MEMBER_GROUP";
})(IdentityType || (IdentityType = {}));
export var MediaType;
(function (MediaType) {
    MediaType["ATTACHMENT"] = "ATTACHMENT";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["FILE"] = "FILE";
})(MediaType || (MediaType = {}));
/** Comment actions */
export var UserAction;
(function (UserAction) {
    UserAction["VIEW"] = "VIEW";
    UserAction["ADD_COMMENT"] = "ADD_COMMENT";
    UserAction["REACT"] = "REACT";
    UserAction["UNREACT"] = "UNREACT";
    UserAction["EDIT"] = "EDIT";
    UserAction["DELETE"] = "DELETE";
    UserAction["REPLY"] = "REPLY";
    UserAction["MARK"] = "MARK";
    UserAction["VOTE"] = "VOTE";
    UserAction["REPORT"] = "REPORT";
    UserAction["RATE"] = "RATE";
})(UserAction || (UserAction = {}));
export var CommentStatus;
(function (CommentStatus) {
    CommentStatus["UNKNOWN"] = "UNKNOWN";
    /** comment is published and visible publicly */
    CommentStatus["PUBLISHED"] = "PUBLISHED";
    /** comment is deleted and not visible publicly */
    CommentStatus["DELETED"] = "DELETED";
    /** comment is pending review and not yet visible publicly */
    CommentStatus["UNPUBLISHED"] = "UNPUBLISHED";
})(CommentStatus || (CommentStatus = {}));
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["UNKNOWN"] = "UNKNOWN";
    ModerationStatus["SUBMITTED"] = "SUBMITTED";
    ModerationStatus["IN_MODERATION"] = "IN_MODERATION";
    ModerationStatus["REJECTED"] = "REJECTED";
    ModerationStatus["APPROVED"] = "APPROVED";
})(ModerationStatus || (ModerationStatus = {}));
export var VisibilityType;
(function (VisibilityType) {
    VisibilityType["UNKNOWN"] = "UNKNOWN";
    VisibilityType["PUBLIC"] = "PUBLIC";
    VisibilityType["RESTRICTED"] = "RESTRICTED";
})(VisibilityType || (VisibilityType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["OFFENSIVE_CONTENT"] = "OFFENSIVE_CONTENT";
    Type["OFFENSIVE_MEDIA"] = "OFFENSIVE_MEDIA";
    Type["SPAM"] = "SPAM";
})(Type || (Type = {}));
export var RepliesFillMode;
(function (RepliesFillMode) {
    /** default option, load only one level of replies up to replies_limit */
    RepliesFillMode["NONE"] = "NONE";
    /** load replies in depth up to replies_limit, respecting the defined ordering and reply hierarchy */
    RepliesFillMode["FILL_TO_REPLIES_LIMIT"] = "FILL_TO_REPLIES_LIMIT";
    /** load replies in depth up to comments limit if there are not enough of comments available. Respects the defined ordering and reply hierarchy. Ignores replies_limit value. */
    RepliesFillMode["FILL_TO_COMMENTS_LIMIT"] = "FILL_TO_COMMENTS_LIMIT";
})(RepliesFillMode || (RepliesFillMode = {}));
export var Ordering;
(function (Ordering) {
    Ordering["UNKNOWN"] = "UNKNOWN";
    /** starts with displaying older comments */
    Ordering["OLDEST_FIRST"] = "OLDEST_FIRST";
    /** starts with newest comments */
    Ordering["LATEST_FIRST"] = "LATEST_FIRST";
})(Ordering || (Ordering = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map